export default {
  // labels
  collection: "Collection",
  collections: "Collections",
  all_collections: "All collections",
  product: "Product",
  products: "Products",
  base_product: "Base Product",
  variant: "Variant",
  variants: "Variants",

  // resources
  resource_name: "Name",
  no_name: "No name specified",
  collection_name: "Collection Name",
  base_product_name: "Name",
  base_product_reference: "Reference",
  product_variant_name: "Name",
  product_variant_reference: "Reference",

  // placeholders
  collection_name_placeholder: "Enter a name for the collection",
  product_variant_name_placeholder: "Enter variant name",
  product_variant_reference_placeholder: "Enter variant reference",

  // actions
  view_collection: "View collection",
  create_collection: "Create collection",
  edit_collection: "Edit collection",
  // products
  view_products: "View products",
  create_base_product: "Create Base Product",
  update_base_product: "Update Base Product",
  // variants
  view_variants: "View variants",
  create_product_variant: "Create Variant",
  update_product_variant: "Update Variant",
  // controls
  add_product_here: "Create products here",
  add_variant: "Create variant here",

  // general
  product_info: "Product Information",
  product_specs: "Product Specs",
  attributes: "Attributes",
  products_attributes: "Product Attribute",
  basic_analytics: "Product Analytics",
  issues_encountered: "Issues Encountered",
  product_export_log: "Product Export Log",
  connect_products: "Connecting Product(s) to Manufacturer",

  // files and photos
  files_for: "Files for",
  attached_files: "Attached Files",
  total_files: "Total {count} files",
  no_photos_attached: "No photos have been found.",
  no_files_attached: "No files have been found.",
  photos_reported_issues: "Photos of reported issues",
  filter_issue_photos: "Filter photos of reported issues",

  // delete resource
  confirm_delete: "Are you sure?",
  confirm_delete_body: "Please confirm that you want to delete: {item}",
  item_deleted: "Item deleted",
  item_deleted_confirmation: "The item {item} was successfully deleted"
};
